import React from 'react';
import TextInput from '../../form/TextInput';
import Select from '../../form/Select';
import createForm from "./Form";
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";

class TillForm extends React.Component {

    render() {
        const sortable = true;
        const filterable = true;
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-md-4 col-sm-push-8">
                        <TextInput name={this.props.componentConfig.idfield} value={this.props.values[this.props.componentConfig.idfield]} label="Kód"
                                   role="idfield" {...this.props.getFieldProps(this.props.componentConfig.idfield)}/>
                    </div>
                    <div className="col-md-4 col-md-pull-4">
                        <TextInput name="name" value={ this.props.values.name } saveChanges={this.props.setFieldValue}
                                   label="Megnevezés" placeholder={this.props.values.displayname} {...this.props.getFieldProps("name")}/>
                    </div>
                    <div className="col-md-4 col-md-pull-4">
                        <Select objectValue={false} name="pos" value={ this.props.values.pos } labelKey="name" component="PointOfSale" storeType="local" saveChanges={this.props.setFieldValue}
                                label="Eladási hely (POS)" {...this.props.getFieldProps("pos")}/>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <div className="form-group">
                            <label className="control-label">Gyűjtők</label>
                            <SelectorGrid
                                {...this.props.getFieldProps("vatrates")}
                                componentConfig={this.props.componentConfig}
                                columns={{
                                    "name": {header: 'Név', width: 6, sortable, filterable},
                                }}
                                name={"vatrates"}
                                data={this.props.values}
                                orderBy={{field: "id", direction: "ASC"}}
                            />
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(TillForm);
